import { isAccommodationItem, isExperienceItem } from 'lib/checkout/checkoutUtils'
import { createSelector } from 'reselect'

export const hasBundledAccommodationRate = createSelector(
  (state: App.State) => state.checkout.cart.items,
  (items): boolean => {
    const bundledAccommodationIds = new Set<string>()
    for (const item of items) {
      if (isAccommodationItem(item) && 'isAccomBundle' in item && !!item.isAccomBundle) {
        // Multi opt-in parents carry every selected bundle id; the scalar mirrors the first.
        for (const bundleId of item.accommBundleIds ?? [item.isAccomBundle]) {
          bundledAccommodationIds.add(bundleId)
        }
      }
    }

    if (!bundledAccommodationIds.size) {
      return false
    }

    return items.some(item =>
      isExperienceItem(item) &&
      !!item.isAccomBundle &&
      bundledAccommodationIds.has(item.isAccomBundle),
    )
  },
)
